import { CTAButton } from 'components/CTAButton/CTAButton';
import React from 'react';

import { cx } from '@emotion/css';
import { FAQsView } from '@modules/shared/FAQs/FAQsView';

import { AreasWeCover } from '../AreasWeCover';
import { ListOfServices } from '../ListOfServices';
import { PostCodes } from '../PostCodes';
import { EmergencyComponent } from '../shared/EmergencyComponent';
import { HeroComponent } from '../shared/HeroComponent';
import { ServiceItem } from '../shared/ServiceItem';
import { TitleAndDescComponent } from '../shared/TitleAndDescComponent';
import styles from './Drainage.module.scss';

export const Drainage = () => {
  return (
    <>
      <HeroComponent
        styles={styles}
        imageLink="/images/services/drainage/Drainage Featured.webp"
        imageAlt="Drainage Contractor checking pipes under a sink"
        title="Drainage"
      />

      <section className={styles.services}>
        <div className={styles.root}>
          <div className={styles.services_card_block}>
            <div className={styles.container}>
              <div className={styles.inner_section}>
                <TitleAndDescComponent
                  styles={styles}
                  title="Professional Drain Service in London"
                  description="We unblock and clean your drains. Our drainage experts in London offer quick, effective solutions for any issue, keeping your plumbing happy and your stress levels low. Dependable service whenever you need it."
                />

                <CTAButton
                  title="Book a Drainage Contractor"
                  serviceName="Drainage"
                />

                <div
                  className={cx(
                    styles.wrap_section,
                    styles.service_content_container,
                  )}>
                  <TitleAndDescComponent
                    styles={styles}
                    subTitle="Drainage Services"
                  />
                  <div className={styles.service_items}>
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/drainage/Drainage_cleaning.webp"
                      imgAlt="Inspection of dismantled pipes"
                      title="Drain Cleaning (Bad Smells)"
                      description="Bad smells coming from your drains are often a sign of buildup or blockage. Left untreated, it can lead to bigger plumbing issues and even potential damage to your system.  Our drain cleaning service targets these issues, removing debris and eliminating unpleasant odours to keep your plumbing fresh and flowing smoothly."
                    />

                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/drainage/Blockages.webp"
                      imgAlt="Drainage Contractor inspecting toilet blockage"
                      title="Blockages (Pipework, Toilets, Showers)"
                      description="Blockages in pipes, toilets, or showers can cause serious disruptions if not addressed promptly. Our skilled team is equipped to clear any blockages quickly and effectively, ensuring your drainage system is back to normal and preventing further issues."
                    />

                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/drainage/Drain_repairs.webp"
                      imgAlt="close up of a clean shower drain"
                      title="Drain Repairs & Installation"
                      description="Damaged or outdated drains can compromise your property's plumbing. We offer comprehensive drain repair and installation services, using the latest techniques to ensure reliable and efficient performance. Whether you need a simple repair or a full installation, we’re here to help."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className={styles.root}>
        <EmergencyComponent
          title="Drainage Contractors Near Me"
          imageSrc="/images/services/drainage/Clean Pipes.webp"
          imageAlt="close up of new, clean pipes"
          styles={styles}
          para1="Blocked drains and slow drainage can quickly escalate into major disruptions, causing damage and stress."
          para2="Our experienced drainage contractors provide effective solutions for any issue,  specialising in repairing, unblocking, and maintaining your system. From quick unblock drainage services to thorough inspections, we’ve got you covered."
        />
        <ListOfServices
          styles={styles}
          serrviceList={[
            { name: 'High-Pressure Jetting' },
            { name: 'CCTV Drain Surveys' },
            { name: 'Drainage Pumps' },
            { name: 'Drain Cleaning (Bad Smells)' },
            { name: 'Blockages (Pipework, Toilets, Showers)' },
            { name: 'Drain Repairs & Installation ' },
          ]}
        />
        <AreasWeCover styles={styles} />
        <PostCodes styles={styles} mainPageUrl="/services/drainage" />
        <FAQsView title="Drainage FAQs" faqItems={faqItems} />
      </div>
    </>
  );
};

const faqItems = [
  {
    title: 'What are the signs of a blocked drain?',
    details: `Common signs include slow drainage, unpleasant odours, gurgling sounds, and water backing up in sinks, showers, or toilets. If you notice any of these, it’s best to book our drainage specialist.`,
  },
  {
    title: 'Can I unblock a drain myself?',
    details:
      'You can try using a plunger or a drain cleaner for minor clogs. However, persistent blockages often require professional tools and techniques, like high-pressure water jetting, to fully clear the drain.',
  },
  {
    title: 'How often should I have my drains inspected?',
    details: `It’s a good idea to have your drains professionally inspected every 2 to 3 years, especially if you’ve had blockages in the past. Regular inspections can help prevent major problems.`,
  },
  {
    title: 'What should I do if my drain smells bad?',
    details: `Bad smells often indicate a blockage or buildup in your drains. Our drain cleaning service can remove the source of the odour, while a CCTV survey can identify any underlying issues that need attention.
`,
  },
];
